/* eslint-disable import/no-anonymous-default-export */
import { get, put } from './base/index';
import { API, getUserId } from '../helpers';

export default {
  getConfiguracao: () => get(`${API}/admin/configuracao/${getUserId()}`),
  updateConfiguracao: (form) =>
    put(`${API}/admin/configuracao/${getUserId()}`, form),
};
